import { parsePhoneNumberFromString } from "libphonenumber-js";
export const isValidBrazilPhone = (value) => {
  if (!value) return false;
  try {
    const phone = parsePhoneNumberFromString(value, "BR");

    if (!phone?.isValid()) return false;

    // Dev note:
    // In Brasil, mobile phone numbers have 9 digits (+ 2 more for DDD) and start with 9.
    // Manually treating this case because libphonenumber-js considers them valid
    // even if they start with other digits.
    return /^\d{2}9\d{8}$/.test(phone.nationalNumber);
  } catch (e) {
    return false;
  }
};

export const getBrazilPhoneValidator = (t) => ({
  validator(_, value) {
    if (!value) return Promise.resolve();
    return isValidBrazilPhone(value)
      ? Promise.resolve()
      : Promise.reject(
          new Error(t("Por favor insira um número de telefone válido.")),
        );
  },
});

export default isValidBrazilPhone;

export const formatBrazilPhone = (value) => {
  if (!value) return value;
  try {
    const phone = parsePhoneNumberFromString(value, "BR");
    if (phone) {
      return phone.formatNational();
    }
    return value;
  } catch (e) {
    return value;
  }
};
